import React from 'react';
import { Button, Modal, Icon } from 'semantic-ui-react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  openAddUserModal,
  closeAddUserModal,
  getAllInternalUsers,
  getAccessLogs,
  closeEditInternalUserModalWindow,
  closeDeleteInternalUserModalWindow,
  deletingInternalUser,
  deleteInternalUser,
} from 'state/access/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';
import CreateInternalUserForm from './CreateInternalUserForm';
import ListUsers from './ListUsers';
import AccessLogs from './AccessLogs';
import EditInternalUserForm from './EditInternalUserForm';
import DeleteInternalUserForm from './DeleteInternalUserForm';

class AccessPage extends React.Component {
  constructor() {
    super();
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const payloadInternalUsers = { page: 1, size: 10 };
    const payloadAccessLogs = {
      currState: {},
      requestMetadata: {
        group: 'access',
        item: '',
        page: 1,
        size: 20,
      },
    };
    dispatch(getAllInternalUsers(payloadInternalUsers));
    dispatch(getAccessLogs(payloadAccessLogs));
  }

  onAddUserButtonClicked = () => {
    const { dispatch } = this.props;
    dispatch(openAddUserModal());
  };

  onCloseAddUserModalClicked = () => {
    const { dispatch } = this.props;
    dispatch(closeAddUserModal());
  };

  onCloseEditUserModalClicked = () => {
    const { dispatch } = this.props;
    dispatch(closeEditInternalUserModalWindow());
  };

  onCloseDeleteUserModalClicked = () => {
    const { dispatch } = this.props;
    dispatch(closeDeleteInternalUserModalWindow());
  };

  onUserDelete = () => {
    const { dispatch, deleteModal } = this.props;
    dispatch(deletingInternalUser(true));
    dispatch(deleteInternalUser(deleteModal.selectedUser));
  };

  render() {
    const { addUserModal, editModal, deleteModal } = this.props;
    return (
      <>
        <h1>Access</h1>
        <br />
        {/* add user modal  */}
        <Modal open={addUserModal}>
          <Modal.Header>
            <strong>Add New User</strong>
          </Modal.Header>
          <Modal.Content>
            <CreateInternalUserForm />
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.onCloseAddUserModalClicked}>
              <Icon name="close" /> Close
            </Button>
          </Modal.Actions>
        </Modal>
        {/* edit user modal  */}
        <Modal open={editModal.isOpen}>
          <Modal.Header>
            <strong>Edit User</strong>
          </Modal.Header>
          <Modal.Content>
            <EditInternalUserForm />
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.onCloseEditUserModalClicked}>
              <Icon name="close" /> Close
            </Button>
          </Modal.Actions>
        </Modal>
        {/* delete user modal  */}
        <Modal size="small" open={deleteModal.isOpen}>
          <Modal.Header>
            <strong>Delete User</strong>
          </Modal.Header>
          <Modal.Content>
            <DeleteInternalUserForm />
          </Modal.Content>
          <Modal.Actions>
            <Button primary inverted onClick={this.onUserDelete}>
              <Icon name="user delete" /> Yes
            </Button>
            <Button color="red" onClick={this.onCloseDeleteUserModalClicked}>
              <Icon name="close" /> No
            </Button>
          </Modal.Actions>
        </Modal>
        {!addUserModal && !editModal.isOpen && !deleteModal.isOpen ? (
          <SemanticToastContainer />
        ) : (
          <></>
        )}
        <Button primary inverted compact onClick={this.onAddUserButtonClicked}>
          <Icon name="add" />
          Add New User
        </Button>
        <ListUsers />
        <AccessLogs />
        <br />
      </>
    );
  }
}

const mapStateToProps = ({ access }) => ({
  addUserModal: access.addUserModal,
  accessLogs: access.accessLogs,
  editModal: access.editModal,
  deleteModal: access.deleteModal,
});

AccessPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  addUserModal: PropTypes.bool.isRequired,
  editModal: PropTypes.object.isRequired,
  deleteModal: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AccessPage);
